import { useAnalyticsFeatureFlags } from '@/analytics/snowplow/hooks/useAnalyticsFeatureFlags';
import { useAnalyticsTracking, useEmitUiEvent } from '@montugroup/data-collection';
import { useCallback } from 'react';

export const useWaitingRoomTracking = () => {
  const emitEvent = useEmitUiEvent();
  const { flags } = useAnalyticsTracking();
  const analyticsFlags = useAnalyticsFeatureFlags();

  const trackWaitingRoomNotification = useCallback(
    (consultationId: number | undefined) => {
      emitEvent(
        {
          component_name: 'PatientJoinedNotification',
          event_name: 'patient_joined_waiting_room_notification_popup',
          id: 'patient_joined_waiting_room_notification',
        },
        {
          consultation: {
            consultation_id: String(consultationId),
          },
          ...(flags?.flags ? {} : { flags: analyticsFlags }),
        },
      );
    },
    [analyticsFlags, emitEvent, flags],
  );

  const trackWaitingRoomNotificationClick = useCallback(
    (consultationId: number) => {
      emitEvent(
        {
          component_name: 'GoToCalendarLink',
          event_name: 'go_to_calendar_link_click',
          id: 'go_to_calendar_link',
        },
        {
          consultation: {
            consultation_id: String(consultationId),
          },
          ...(flags?.flags ? {} : { flags: analyticsFlags }),
        },
      );
    },
    [analyticsFlags, emitEvent, flags],
  );

  return {
    trackWaitingRoomNotification,
    trackWaitingRoomNotificationClick,
  };
};
